const countryOptions = [
    {
        name: "United States of America",
        value: "USA"
    }
]
export default countryOptions;


/** WEBPACK FOOTER **
 ** ./src/forms/options/countries.js
 **/